import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "../Pages/Home/HomePage";
import ProductPage from "../Pages/Product/ProductPage";
import Store from "../Pages/Store/Store";
import Search from "../Pages/Search/Search";
import Login from "../Pages/Auth/Login";
import SignUp from "../Pages/Auth/Signup";
import AboutUs from "../Pages/AdditionalPages/AboutUs";
import TermsOfUse from "../Pages/AdditionalPages/TermsOfUse";
import PrivacyPolicy from "../Pages/AdditionalPages/PrivacyPolicy";
import AffiliateDisclosure from "../Pages/AdditionalPages/AffiliateDisclosure";
import Dashboard from "../Pages/Dashboard/dashboard.jsx";

const Router = () => {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/store" element={<Store />} />
        <Route path="/search" element={<Search />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/affiliate-disclosure" element={<AffiliateDisclosure />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
